import React from "react"

import Blogs from "../components/Blogs"
import Contact from "../components/Contact"
import Education from "../components/Education"
import Experience from "../components/Experience"
import Landing from "../components/Landing"
import Navbar from "../components/Navbar"
import Projects from "../components/Projects"
import TechStack from "../components/TechStack"
import ScrollButton from "../components/widgets/backToTop"
import Seo from "../components/SEO"

import "../styles/global.css"

export default function Main() {
  return (
    <React.Fragment>
      <Seo title="Home" />
      <div className="nav">
        <Navbar></Navbar>
      </div>
      <div className="notNav">
        <Landing></Landing>
        <TechStack></TechStack>
        <Education></Education>
        <Experience></Experience>
        <Projects></Projects>
        <Blogs></Blogs>
        <Contact></Contact>
        <ScrollButton></ScrollButton>
      </div>
    </React.Fragment>
  )
}
